module.exports = __webpack_public_path__ + "img/Vadkanmangora.3e85ce16.png";